import {
    createContext,
    useCallback,
    useContext,
    useEffect,
    useState,
} from "react";
import { getConfig } from "../services/authService";
import { getAdpEmployee } from "../services/api-services/adpAPIService";
import { EmployeeData } from "../models/adpModels";
import { ConfigData } from "../models/config";
import Logo from "../assets/logo/1800AccountantLogo.svg";

const FULFILLED = 'fulfilled';
export const IMG_BASE_URL = 'https://1800-partner-logos.s3.amazonaws.com'; 
export const IMAGE_NAMES = {
    LOGO : 'partnerLogo.svg'
}

export const hasEmpty = (partnerDetails: any) => {
    return (
        !partnerDetails ||
        (Array.isArray(partnerDetails) && partnerDetails.length === 0)
    );
}

export const getPartnerLogo = (businessPartner: string) : string =>{
    return `${IMG_BASE_URL}/${businessPartner}/${IMAGE_NAMES.LOGO}`
}


export const AppContext = createContext(null);

export function useAppState(): any {
    const state = useContext(AppContext);
    return state;
}

const changeToPartnerFaviconIcon = (newIconPath: string) => {
    const oldFavicon = document.querySelector('link[rel="icon"]')
    const newFavicon = document.createElement('link')
    newFavicon.rel = 'icon'
    newFavicon.href = newIconPath
    if (oldFavicon) {
        document.head.removeChild(oldFavicon)
    }
    document.head.appendChild(newFavicon)
}



export const AppProvider = ({ children }: any) => {
    const [config, setConfig] = useState<ConfigData>();
    const [isApiLoading, setIsApiLoading] = useState(false);
    const [employeeDetails, setEmployeeDetails] = useState<EmployeeData>();
    const [logo, setLogo] = useState(Logo); 


    const setRootStyles = (empStyles: any) => {
        Object.keys(empStyles).forEach(key => {
            document.documentElement.style.setProperty(`--${key}`, empStyles[key]);
        });
    }

    const loadEmployeeData = useCallback(() => {
        setIsApiLoading(true);
        Promise.allSettled([getConfig(), getAdpEmployee()])
            .then((results: any) => {
                if (results[0].status === FULFILLED) {
                    const employeeData = results[0].value.data?.employees
                    setConfig(results[0].value.data);
                    const partnerDetails = employeeData?.partner_details;
                    const empStyles: any = employeeData?.partner_details.employee_web_style

                    if (hasEmpty(partnerDetails)) {
                        setLogo(Logo);
                        localStorage.setItem("companyLogo", Logo);
                    } else {
                        const partnerLogoPath =  `${IMG_BASE_URL}/${partnerDetails?.partner_key}/${IMAGE_NAMES.LOGO}`
                        setLogo(partnerLogoPath);
                        localStorage.setItem("companyLogo", partnerLogoPath);
                        setRootStyles(empStyles)
                        changeToPartnerFaviconIcon(partnerLogoPath)
                    }
                } else {
                    setIsApiLoading(false);
                }
                if(results[1].status === FULFILLED) {
                    setEmployeeDetails(results[1].value.data)
                } else {
                     setIsApiLoading(false);
                }
                setIsApiLoading(false);
            }).catch((err) => {
                setIsApiLoading(false);
            });
    }, []);

    useEffect(() => {
        if (!employeeDetails) {
            loadEmployeeData();
        }
    }, [employeeDetails, loadEmployeeData]);

    const providerValues: any = {
        config,
        employeeDetails,
        isApiLoading,
        setIsApiLoading,
        setEmployeeDetails,
        loadEmployeeData,
        logo
    };
    return (
        <AppContext.Provider value={providerValues}>
            {children}
        </AppContext.Provider>
    );
};
